import * as api from "@/js/api/api";

interface FeatureTogglesResponse {
	result: FeatureToggles;
}

export interface FeatureToggles {
	"classwize-teacher-student-chat": boolean;
	"connection-search-report": boolean;
	"hide-courses-tab": boolean;
	"show-manage-user-password": boolean;
	"shr-enabled": boolean;
	global_rules_validation_enabled: boolean;
	rules_validation_enabled: boolean;
	"show-courses-tab": boolean;
	"show-classwize-training": boolean;
	"agent-p2p-screenshots": boolean; // TODO deprecated?
	"hide-status-page-banner"?: boolean;
}

export const getLinewizeFilterFeatureFlags = async (options = {}): Promise<FeatureToggles> => {
	const res = (await api.get("/backend/config/feature-flags", options)) as FeatureTogglesResponse;
	return res.result;
};
